import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Announcement } from '../../models/announcement/announcement.model';
import { AnnouncementService } from '../../services/announcement/announcement.service';
import { CustomerService } from '../../services/customer/customer.service';
import { Customer } from '../../models/customer/customer-model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-announcement-list',
    templateUrl: './announcement-list.component.html',
    styleUrls: ['./announcement-list.component.css']
})
/** announcement-list component*/
export class AnnouncementListComponent {
  public announcementList: Announcement[];
  public customerList: Customer[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  //Filter items from grid
  filteredItems: any[];
  customerID: number=0;
  isActive: string="";
  public searchKeyword: string;
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** announcement-list ctor */
  constructor(
    private readonly announcementService: AnnouncementService,
    private readonly utilitiesService: UtilitiesService,
    private readonly customerService: CustomerService,
    private readonly toastr: ToastsManager,
    vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.toastr.setRootViewContainerRef(vcr);
    this.rolePermissionService.GetRolePermissions("announcement").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
            this.GetAnnouncements();
            this.getVendors();
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  GetAnnouncements() {
    this.announcementService.GetAnnouncements().subscribe(
      data => {
        this.announcementList = data
        this.filteredItems = data;
      }
    )
  }
  getVendors() {
    this.customerService.getVendorsList().subscribe(
      data => {
        this.customerList = data;
      }
    )
  }
  deleteAnnouncement(id) {
    var ans = confirm("Are you sure to delete this announcement");
    if (ans) {
      this.announcementService.DeleteAnnouncement(id);
      this.toastr.success('Announcement deleted successfully.', 'Success');
      setTimeout(() => {
        this.GetAnnouncements();
      }, 3000);

    }
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  OnFilterChange() {
    this.filteredItems = this.announcementList;

    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    } else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }
    if (this.customerID > 0) {
      this.filteredItems = this.filteredItems.filter(s => s.customerID == this.customerID);
    }
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/announcement-components/announcement-list/announcement-list.component.ts